// --------------------------------------------------------------------------
// toggleCards.js
// --------------------------------------------------------------------------
// Toggles a toggleCards
// --------------------------------------------------------------------------

RN.toggleCards = function() {

  'use strict';

  function init() {
    byBehaviour('toggle-cards').on('click', toggleCards);
  }

  function toggleCards() {
    var thisButton = $(this)
    var buttonText = thisButton.text();
    var extraCards = thisButton.closest(byElement('card-wrap')).find(byElement('card'))
    extraCards.toggleClass('exhibit-listing--hidden')
    thisButton.text(buttonText === 'View More' ? 'View Less' : 'View More')
    return false;
  }

  return {
    init: init
  };

}();